import React, { useEffect, useState } from 'react';
import styles from './index.module.scss';
import DataTable from 'components/DataTable';
import {  showError  } from 'utils';
import { tableStyles } from 'css/tableStyles';
import { fetchInactiveInventoryItemsWithStock } from 'services';
import { Loading } from 'components/loading/Loading';
import ExportCSVButton from 'components/ExportCSVButton';
import InventoryItemId from 'components/InventoryItemId';

const columnsForCSV = [
  {
    label: 'Item ID',
    value: 'objectId',
  },
  {
    label: 'Name',
    value: 'name',
  },
  {
    label: 'Category',
    value: 'category.description',
  },
  {
    label: 'Stock',
    value: 'stock',
  },
  {
    label: 'Price',
    value: 'price',
  },
  {
    label: 'Unit',
    value: 'unit.description',
  },
];

const columns = [
  {
    name: 'Item ID',
    selector: 'objectId',
    sortable: false,
    // eslint-disable-next-line react/display-name
    cell: row => (
      <InventoryItemId itemDetails={row} />
    ),
  },
  {
    name: 'Image',
    selector: 'name',
    // eslint-disable-next-line react/display-name
    cell: (row: any) => (
      <div className={styles['item-name-and-image']}>
        {row.image?.url ? (
          <img src={row.image.url} alt={'item-image'} />
        ) : null}
        
      </div>
    ),
  },
  {
    name: 'Name',
    selector: 'name',
    sortable: false,
  },
  {
    name: 'Category',
    selector: 'category.description',
    sortable: false,
  },
  {
    name: 'Stock',
    selector: 'stock',
    sortable: false,
  },
  {
    name: 'Price',
    selector: 'price',
    sortable: false,
  },
  {
    name: 'Unit',
    selector: 'unit',
    sortable: false,
    cell: row => (
      <div>{row.unit?.description || '-'}</div>
    ),
  },
];

const InactiveInventoryItemWithStock = () => {
  const [data, setData] = useState<Record<string, any>[]>([]);
  const [filterData, setFilterData] = useState<Record<string, any>[]>([]);
  const [searchKey, setSearchKey] = useState<string>('');
  const [loading, setLoading] = useState<boolean>(false);

  const fetchReport = async () => {
    setLoading(true);
    try {
      const response = await fetchInactiveInventoryItemsWithStock();
      setData(response);
      setFilterData(response);
    } catch (e) {
      showError(e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchReport();
  }, []);

  const onFilter =(searchText)=>{
    if(searchText){
      const tableData = data.filter(obj=>(
        obj?.name.toLowerCase().includes(searchText.toLowerCase())),
      );
      setFilterData(tableData);
    }else{
      setFilterData(data);
    }
    setSearchKey(searchText);
  };

  const getDataTable = () => {
    if (loading) return <Loading type={'mini'} />;

    return (
      <DataTable
        keyField="objectid"
        columns={columns}
        data={filterData}
        highlightOnHover={true}
        customStyles={tableStyles}
        title={
          <div className='d-flex flex-row align-items-center'>
            <input
              type={'text'}
              key={'saa'}
              className={'form-control'}
              placeholder={'Search Item Name'}
              defaultValue={searchKey}
              onChange={e => onFilter(e.target.value)}
              style={{ width: '35%' }}
            />
            <span className='ml-2'>Displaying {filterData?.length} item(s)</span>
          </div>
        }
        actions={[
          <ExportCSVButton
            data={data}
            key={`inventory-item`}
            fileName={`Inactive_Inventory_Item_With_Stock_Report`}
            columnsForCSV={columnsForCSV}
          />,
        ]}
      />
    );
  };

  return (
    <>
      <div className={styles['header']}>
        <div className={styles['heading']}>Inactive Inventory Item With Stock Report</div>
        
      </div>
      {getDataTable()}
    </>
  );
};

export default InactiveInventoryItemWithStock;